import { getPrePacksPrefix } from "../helpers";
import * as React from "react";
export const NoBets = (props) => {
    const baseClassName = getPrePacksPrefix("noBets");
    return (React.createElement("div", { className: `${baseClassName}-screen`, "data-testid": "wrapper-prepacks-no-bets" },
        React.createElement("div", { className: baseClassName },
            React.createElement("h3", { className: `${baseClassName}__title` }, props.title),
            React.createElement("p", { className: `${baseClassName}__info` }, props.info),
            props.children)));
};
//# sourceMappingURL=NoBets.js.map